import { setConfigGroups } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@casops/filters/types';
import MultiselectFilter from '../multiselect/MultiselectFilter';
import { useMemo } from 'react';
import {
  ConfigurationGroupBasicModel,
  useListConfigurationGroupsQuery,
} from '@casops/store/apis/configurationGroupsApi';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

const useConfigGroupOptions = (): DropdownItemProps<string>[] => {
  const { data: configGroups } = useListConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo(() => {
    return configGroups
      ? configGroups.map(({ id, name }: ConfigurationGroupBasicModel) => {
          const value = id.toString();
          return { key: value, value, stringValue: value, label: name };
        })
      : [];
  }, [configGroups]);
};

export const ConfigGroupsFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();
  return (
    <MultiselectFilter<string>
      filterName="configGroups"
      label={label ?? t('Fields.Filters.ConfigurationGroup')}
      action={setConfigGroups}
      elementRef={elementRef}
      useItemsHook={useConfigGroupOptions}
    />
  );
};

export default ConfigGroupsFilter;
